import type {
    GetCommerceProductCategoryRequest,
    GetCommerceProductCategoryResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceProductCategoryOperation = defineCommerceOperation<
    GetCommerceProductCategoryRequest,
    GetCommerceProductCategoryResponse
>("commerce.product-categories.get");
